import { Component, ElementRef } from '@angular/core';
import { StatisticsService } from '../../services/statistics.service';
import { LineComponent } from "../../charts/line/line.component";
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { DonutComponent } from "../../charts/donut/donut.component";
import { Chart, registerables } from 'chart.js';
import { UserService } from '../../services/user.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-my-statistics',
  standalone: true,
  imports: [CommonModule, NgIf, LineComponent, DonutComponent, RouterModule],
  templateUrl: './my-statistics.component.html',
  styleUrl: './my-statistics.component.scss'
})
export class MyStatisticsComponent {
  total: number = 0;
  total7: number = 0;
  total15: number = 0;
  total30: number = 0;
  averagePerDay: string = '0';
  correctPercentage: number = 0;
  answerRank: number = 0;
  correctRank: number = 0;
  dates: string[] = [];
  correctsData: number[] = [];
  wrongsData: number[] = [];
  correctsTotal: number = 0;
  wrongsTotal: number = 0;
  percentMessage: string = 'Não desista! Você pode melhorar ainda mais!';
  bancasStats: any[] = [];
  subjectsStats: any[] = [];
  questionTypeData: any = {};
  isLoading: boolean = true;
  isFreePlan: boolean = false;
  constructor(
    private statisticsService: StatisticsService,
    private elementRef: ElementRef,
    private userService: UserService
  ) {
    Chart.register(...registerables);
  }

  ngOnInit() {
    this.checkUserPlan();
  }
checkUserPlan() {
  const userId = Number(localStorage.getItem('id'));
  if (!userId) {
    this.isFreePlan = true;
    this.isLoading = false;
    return;
  }

  this.userService.getUserPlan(userId).subscribe({
    next: (response) => {
      this.isFreePlan = response?.plan?.toLowerCase() === 'free';
      if (!this.isFreePlan) {
        this.userStatistics();
        this.chartsGenerate();
      } else {
        this.isLoading = false;
      }
    },
    error: (err) => {
      console.error('Erro ao buscar plano do usuário', err);
      this.isFreePlan = true;
      this.isLoading = false;
    }
  });
}

  userStatistics() {
    this.statisticsService.userStatistics().subscribe({
      next: (response) => {
        this.total = response.total;
        this.total7 = response.last_7;
        this.total15 = response.last_15;
        this.total30 = response.last_30;
        this.averagePerDay = Number(response.averagePerDay).toFixed(1);
        this.correctPercentage = parseFloat(response.rightPercent.toFixed(2));
        this.answerRank = response.userResponseRank;
        this.correctRank = response.userRightRank;
        this.dates = response.performance.map((p) => new Date(p.day).toLocaleDateString());
        this.correctsData = response.performance.map((p) => p.correct);
        this.wrongsData = response.performance.map((p) => p.wrong);
        this.correctsTotal = response.right;
        this.wrongsTotal = response.wrong;

        if (this.correctPercentage >= 90) {
          this.percentMessage = 'Excelente! Você está mandando muito bem!';
        } else if (this.correctPercentage >= 80) {
          this.percentMessage = 'Ótimo trabalho! Continue assim!';
        } else if (this.correctPercentage >= 70) {
          this.percentMessage = 'Bom trabalho! Você está quase lá!';
        } else if (this.correctPercentage >= 50) {
          this.percentMessage = 'Está indo bem! Com mais dedicação, você chega lá!';
        }

        this.isLoading = false;
      },
      error: (error: any) => {
        console.error('Erro ao carregar as estatísticas', error);
        this.isLoading = false;
      }
    });
  }

  chartsGenerate() {
    this.statisticsService.userCharts().subscribe({
      next: (response) => {
        this.bancasStats = response.bancas;
        this.subjectsStats = response.subjects;
        this.questionTypeData = response.questionType;

        this.createBancasChart();
        this.createSubjectsChart();
        this.createQuestionTypeChart();
      },
      error: (error: any) => {
        console.error('Erro ao carregar os gráficos', error);
      }
    });
  }

  createBancasChart() {
    const canvas = this.elementRef.nativeElement.querySelector('#bancas_chart');
    if (canvas && this.bancasStats.length > 0) {
      new Chart(canvas, {
        type: 'bar',
        data: {
          labels: this.bancasStats.map(b => b.banca),
          datasets: [
            {
              label: 'Corretas',
              data: this.bancasStats.map(b => b.correct_answers),
              backgroundColor: 'rgba(75, 192, 192, 0.6)',
            },
            {
              label: 'Erradas',
              data: this.bancasStats.map(b => b.wrong_answers),
              backgroundColor: 'rgba(255, 99, 132, 0.6)',
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: 'Desempenho por Banca Examinadora'
            },
            legend: { position: 'top' },
          },
          scales: {
            x: { title: { display: true, text: 'Bancas Examinadoras' } },
            y: { beginAtZero: true, title: { display: true, text: 'Quantidade de Respostas' } },
          },
        },
      });
    }
  }

  createSubjectsChart() {
    const canvas = this.elementRef.nativeElement.querySelector('#subjects_chart');
    if (canvas && this.subjectsStats.length > 0) {
      new Chart(canvas, {
        type: 'bar',
        data: {
          labels: this.subjectsStats.map(s => s.subject),
          datasets: [
            {
              label: 'Corretas',
              data: this.subjectsStats.map(s => s.correct_answers),
              backgroundColor: 'rgba(54, 162, 235, 0.6)',
            },
            {
              label: 'Erradas',
              data: this.subjectsStats.map(s => s.wrong_answers),
              backgroundColor: 'rgba(255, 99, 132, 0.6)',
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: 'Desempenho por Assunto'
            },
            legend: { position: 'top' },
          },
          scales: {
            x: { title: { display: true, text: 'Assuntos' } },
            y: { beginAtZero: true, title: { display: true, text: 'Quantidade de Respostas' } },
          },
        },
      });
    }
  }

  createQuestionTypeChart() {
    const canvas = this.elementRef.nativeElement.querySelector('#type_chart');
    if (canvas && this.questionTypeData) {
      new Chart(canvas, {
        type: 'bar',
        data: {
          labels: ['Múltipla Escolha', 'Verdadeiro ou Falso'],
          datasets: [
            {
              label: 'Corretas',
              data: [
                this.questionTypeData.multiple?.correct || 0,
                this.questionTypeData.TF?.correct || 0
              ],
              backgroundColor: 'rgba(153, 102, 255, 0.6)',
            },
            {
              label: 'Erradas',
              data: [
                this.questionTypeData.multiple?.wrong || 0,
                this.questionTypeData.TF?.wrong || 0
              ],
              backgroundColor: 'rgba(255, 99, 132, 0.6)',
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: 'Desempenho por Tipo de Questão'
            },
            legend: { position: 'top' },
          },
          scales: {
            x: { title: { display: true, text: 'Tipo de Questão' } },
            y: { beginAtZero: true, title: { display: true, text: 'Quantidade de Respostas' } },
          },
        },
      });
    }
  }
}